import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Modal,
  Button,
  Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "../../../services/AxiosInstance";
import Swal from 'sweetalert2';
import { MAUURL } from "../../../constant";
import { isObject } from "formik";

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

let search = window.location.search;
let params = new URLSearchParams(search);
let id = params.get('id');

const Monitoring = () => {

  const [studentsData, setStudentsData] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
    from: 0,
    to: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emailList, setEmailList] = useState([]);

  const [ujianData, setUjianData] = useState(null);
  const [periodicToken, setPeriodicToken] = useState(null);
  const periodicTokenTimerRef = React.useRef(null);

  useEffect(() => {
    const tokenTag = (ujianData?.detail?.tags || []).find(
      (t) => typeof t === "string" && t.toLowerCase().startsWith("token-")
    );
    const hasPeriodicToken = !!tokenTag;
    const tokenDurationMinutes = hasPeriodicToken ? (parseInt(tokenTag.split("-")[1]) || 15) : 15;

    if (!ujianData || !hasPeriodicToken) {
      setPeriodicToken(null);
      return;
    }

    const fetchPeriodicToken = () => {
      axiosInstance.get(`/test-online/guru/ujian/${id}/token-info`)
        .then((res) => {
          const data = res.data?.data;
          setPeriodicToken(data?.token ?? null);
          // Schedule next fetch right after token resets (add 500ms buffer)
          const fallbackSeconds = tokenDurationMinutes * 60;
          const delay = ((data?.seconds_remaining ?? fallbackSeconds) * 1000) + 500;
          periodicTokenTimerRef.current = setTimeout(fetchPeriodicToken, delay);
        })
        .catch(() => {
          setPeriodicToken(null);
          // Retry after 10 seconds if network request fails
          periodicTokenTimerRef.current = setTimeout(fetchPeriodicToken, 10000);
        });
    };

    fetchPeriodicToken();
    return () => {
      if (periodicTokenTimerRef.current) clearTimeout(periodicTokenTimerRef.current);
    };
  }, [ujianData]);

  useEffect(() => {
    if (id == "null" || !id) {
      Swal.fire({
        title: "Invalid Akses",
        text: "Anda akan di arahkan ke MAU. Silahkan masuk kembali ke Test Online melalui Tombol 'Ujikan' yang ada di MAU.",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Saya mengerti",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = MAUURL + '/daftar-ujian/test-online';
        }
      });
      return;
    }

    getUjianDetail(currentPage, searchQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const getUjianDetail = async (page = 1, search = "") => {
    try {
      Swal.fire({
        title: 'Loading...',
        html: 'Sedang memuat data peserta ujian.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // /ujian/detail-jawaban/peserta/20
      const params = {
        page: page,
        ...(search && { search: search })
      };

      var ujian = await axiosInstance.get(`ujian/${id}?without_peserta=true`);

      console.log("ujian", ujian);

      setUjianData(ujian.data.data);

      var res = await axiosInstance.get(`ujian/${id}/peserta`, { params });
      console.log("getUjianDetail", res);
      var data = res.data;

      // Set pagination info
      if (data) {
        // If response is paginated
        setPagination({
          current_page: data.current_page,
          last_page: data.last_page,
          per_page: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to
        });

        var tmp = []
        for (var i = 0; i < data.data.length; i++) {
          tmp.push({
            id: data.data[i].id,
            kelas: data.data[i].detail.kelas,
            rombel: data.data[i].detail.rombel,
            nama_siswa: data.data[i].user.name,
            user_id: data.data[i].user?.id,
            is_blocked: data.data[i].user?.is_blocked,
            guru_pengampu: data.data[i].detail.wali_kelas,
            token: (data.data[i].detail.tags || []).includes("static_token") ? data.data[i].detail.token : data.data[i].status == "created" ? data.data[i].detail.token : data.data[i].detail.token,
            status: data.data[i].status,
            nilai_bobot: ujian.data.data.type == 'open-test' ? (data.data[i].result != null ? data.data[i].result.nilai_bobot : "-") : data.data[i].nilai_bobot
          })
        }
        setStudentsData(tmp);
      }
      Swal.close();
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load data. Please try again.'
      });
    }
  }

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    getUjianDetail(1, searchQuery);
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  }

  const renderPagination = () => {
    if (pagination.last_page <= 1) return null;

    const pages = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, pagination.current_page - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(pagination.last_page, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Previous button
    pages.push(
      <li key="prev" className={`page-item ${pagination.current_page === 1 ? 'disabled' : ''}`}>
        <button
          className="page-link px-5 py-2"
          onClick={() => pagination.current_page > 1 && handlePageChange(pagination.current_page - 1)}
          disabled={pagination.current_page === 1}
        >
          Previous
        </button>
      </li>
    );

    // First page
    if (startPage > 1) {
      pages.push(
        <li key={1} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="ellipsis1" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${pagination.current_page === i ? 'active' : ''}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>{i}</button>
        </li>
      );
    }

    // Last page
    if (endPage < pagination.last_page) {
      if (endPage < pagination.last_page - 1) {
        pages.push(
          <li key="ellipsis2" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li key={pagination.last_page} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(pagination.last_page)}>
            {pagination.last_page}
          </button>
        </li>
      );
    }

    // Next button
    pages.push(
      <li key="next" className={`page-item ${pagination.current_page === pagination.last_page ? 'disabled' : ''}`}>
        <button
          className="page-link"
          onClick={() => pagination.current_page < pagination.last_page && handlePageChange(pagination.current_page + 1)}
          disabled={pagination.current_page === pagination.last_page}
        >
          Next
        </button>
      </li>
    );

    return pages;
  }

  const handleShowAddModal = () => {
    setShowAddModal(true);
    setEmailInput("");
    setEmailList([]);
  }

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setEmailInput("");
    setEmailList([]);
  }

  const handleAddEmail = (e) => {
    e.preventDefault();
    if (emailInput.trim()) {
      // Split by comma and trim whitespace
      const emails = emailInput.split(',').map(email => email.trim()).filter(email => email !== '');

      // Add to list if not already exists
      const newEmails = emails.filter(email => !emailList.includes(email));
      setEmailList([...emailList, ...newEmails]);
      setEmailInput("");
    }
  }

  const handleRemoveEmail = (emailToRemove) => {
    setEmailList(emailList.filter(email => email !== emailToRemove));
  }

  const handleSaveEmails = async () => {
    if (emailList.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Peringatan',
        text: 'Tidak ada email yang akan ditambahkan.'
      });
      return;
    }

    try {
      Swal.fire({
        title: 'Processing...',
        html: 'Sedang menambahkan peserta...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Send batch request with array of emails
      const response = await axiosInstance.post(`ujian/${id}/add/peserta/batch`, {
        emails: emailList
      });

      Swal.close();

      // Show success result
      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: `Berhasil menambahkan ${emailList.length} peserta.`
      });
      handleCloseAddModal();
      getUjianDetail(currentPage, searchQuery);
    } catch (error) {
      console.error("Error adding participants:", error);
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Terjadi kesalahan saat menambahkan peserta.'
      });
    }
  }

  const handleDeletePeserta = async (student) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Konfirmasi Hapus',
      html: `Apakah Anda yakin ingin menghapus peserta:<br/><strong>${student.nama_siswa}</strong>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batal'
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: 'Processing...',
          html: 'Sedang menghapus peserta...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Delete request
        await axiosInstance.delete(`ujian/delete/peserta/${student.id}`, {
          data: {
            email: student.id
          }
        });

        Swal.close();

        // Show success message
        Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: 'Peserta berhasil dihapus.'
        });

        // Refresh data
        getUjianDetail(currentPage, searchQuery);
      } catch (error) {
        console.error("Error deleting participant:", error);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Terjadi kesalahan saat menghapus peserta.'
        });
      }
    }
  }

  const handleToggleBlock = async (student) => {
    const actionText = student.is_blocked ? "membuka blokir" : "memblokir";
    const confirmButtonText = student.is_blocked ? "Ya, Buka Blokir!" : "Ya, Blokir!";
    const confirmButtonColor = student.is_blocked ? "#28a745" : "#ffc107";

    const result = await Swal.fire({
      title: `Konfirmasi ${student.is_blocked ? "Buka Blokir" : "Blokir"}`,
      html: `Apakah Anda yakin ingin ${actionText} peserta:<br/><strong>${student.nama_siswa}</strong>?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: "#3085d6",
      confirmButtonText: confirmButtonText,
      cancelButtonText: "Batal"
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: "Processing...",
          html: "Sedang memproses permintaan...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const endpoint = `ujian/user/${student.user_id}/${student.is_blocked ? 'unblock' : 'block'}`;
        await axiosInstance.put(endpoint);

        Swal.close();

        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: `Peserta berhasil ${student.is_blocked ? "dibuka blokirnya" : "diblokir"}.`
        });

        getUjianDetail(currentPage, searchQuery);
      } catch (error) {
        console.error("Error toggling block status:", error);
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Terjadi kesalahan saat memproses permintaan."
        });
      }
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Table" motherMenu="Bootstrap" />
      <Row>

        <Col lg={12}>
          <Card>
            <Card.Header>
              {/*<Card.Title>Recent Payments Queue</Card.Title>*/}
              <div className="d-flex justify-content-between align-items-center col-xl-12">
                <div>
                  <form onSubmit={handleSearch} className="input-group search-area mb-0">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button type="submit" className="input-group-text" style={{ cursor: 'pointer', background: 'transparent', border: 'none' }}>
                      <svg width="15" height="15" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z"
                          fill="#01A3FF" />
                      </svg>
                    </button>
                  </form>
                </div>
                <div>
                  <button className="btn btn-primary" onClick={handleShowAddModal}>Tambah Peserta</button>
                </div>
              </div>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Kelas</strong>
                    </th>
                    <th>
                      <strong>Rombel</strong>
                    </th>
                    <th>
                      <strong>Nama Siswa</strong>
                    </th>
                    <th>
                      <strong>Wali Kelas</strong>
                    </th>
                    <th>
                      <strong>Token</strong>
                    </th>
                    <th>
                      <strong>ID Peserta Ujian</strong>
                    </th>
                    <th>
                      <strong>Nilai</strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Aksi</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {studentsData && studentsData.length > 0 ? (
                    studentsData.map((student, index) => (
                      <tr key={index}>
                        <td>
                          <strong>{(pagination.current_page - 1) * pagination.per_page + index + 1}</strong>
                        </td>
                        <td>{student.kelas}</td>
                        <td>{student.rombel}</td>
                        <td>{student.nama_siswa}</td>
                        <td>{student.guru_pengampu}</td>
                        <td>{
                          (ujianData?.detail?.tags || []).some((t) => typeof t === "string" && t.toLowerCase().startsWith("token-"))
                            ? (periodicToken ?? "-")
                            : (ujianData?.detail?.tags || []).includes("static_token")
                              ? ujianData?.detail?.token
                              : student.token
                        }</td>
                        <td>{student.id}</td>
                        <td>{student.nilai_bobot}</td>
                        <td>
                          <Badge bg="" className={student.status == "finished" ? "badge-success" : student.status == "started" ? "badge-warning" : "badge-primary"}>{student.status == "finished" ? "Selesai" : student.status == "started" ? "Sedang Berlangsung" : "Belum Mulai"}</Badge>
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeletePeserta(student)}
                            title="Hapus Peserta"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                          <Button
                            variant={student.is_blocked ? "success" : "warning"}
                            size="sm"
                            className="ms-1"
                            onClick={() => handleToggleBlock(student)}
                            title={student.is_blocked ? "Buka Blokir" : "Blokir Ujian"}
                          >
                            <i className={student.is_blocked ? "fas fa-unlock" : "fas fa-ban"}></i>
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center py-4">
                        No data available
                      </td>
                    </tr>
                  )}

                </tbody>
              </Table>

              {/* Pagination Info */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {pagination.from} to {pagination.to} of {pagination.total} entries
                </div>
                <nav>
                  <ul className="pagination pagination-gutter pagination-primary">
                    {renderPagination()}
                  </ul>
                </nav>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Add Participant Modal */}
      <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg">
        <Modal.Header>
          <Modal.Title>Tambah Peserta</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleCloseAddModal}></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-warning" role="alert">
            <i className="fas fa-exclamation-triangle me-2"></i>
            <strong>Hati-hati!</strong> Pastikan email yang akan ditambahkan belum terdaftar di ujian ini.
          </div>

          <Form onSubmit={handleAddEmail}>
            <Form.Group className="mb-3">
              <Form.Label>Email Peserta</Form.Label>
              <div className="input-group">
                <Form.Control
                  type="text"
                  placeholder="Masukkan email (pisahkan dengan koma untuk multiple email)"
                  value={emailInput}
                  onChange={(e) => setEmailInput(e.target.value)}
                />
                <Button type="submit" variant="primary">
                  <i className="fas fa-plus me-1"></i> Tambah
                </Button>
              </div>
              <Form.Text className="text-muted">
                Contoh: email1@gmail.com, email2@gmail.com
              </Form.Text>
            </Form.Group>
          </Form>

          {emailList.length > 0 && (
            <div className="mt-4">
              <h5 className="mb-3">Daftar Email yang Akan Ditambahkan ({emailList.length})</h5>
              <Table responsive bordered striped>
                <thead>
                  <tr>
                    <th style={{ width: '50px' }}>#</th>
                    <th>Email</th>
                    <th style={{ width: '80px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {emailList.map((email, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{email}</td>
                      <td className="text-center">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleRemoveEmail(email)}
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAddModal}>
            Batal
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveEmails}
            disabled={emailList.length === 0}
          >
            <i className="fas fa-save me-1"></i> Simpan ({emailList.length})
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );

}

export default Monitoring;